import React from 'react';
import $ from 'jquery';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
});
class Channels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
  };
  toggleMenu = () => {
    this.setState({open: !this.state.open});
  };
  render = () => {
    const overlay = this.props.channelLoaded && this.props.overlay;
    if (!overlay || this.props.isFullscreen) {
      return (<div/>);
    }
    const services = this.props.services.services;
    const activeServiceId = this.props.activeServiceId;
    const list = [];
    const self = this;
    $(services).each(function() {
      const service = this;
      const key = 'channel-' + service.service_id;
      list.push(
        <Channel
          key={key}
          service={service}
          selected={activeServiceId === service.service_id}
          onSelectChannel={self.props.onSelectChannel}
        />
      );
    });
    const style = {
      top: 40,
      minWidth: 40,
      color:'white',
      position: 'absolute',
      backgroundColor: this.state.open? '#666' : '#212121'
    };

    // const iconStyle = {
    //
    // };
    const icon= this.state.open? <CloseIcon/> : <AddIcon />;
    const listStyle = {display: this.state.open? 'block': 'none',
      left: '60px', top: '48px', position: 'absolute',
      backgroundColor: '#333', whiteSpace: 'pre'
    };
    return (
      <div>
        <IconButton
          style={style}
          onMouseMove={this.handleMouseEnterOrMouseMove}
          onMouseLeave={this.handleMouseLeave}
          onClick={this.toggleMenu}
        >
          {icon}
        </IconButton>
        <div
          id="channel_list"
          style={listStyle}
          onMouseEnter={this.handleMouseEnterOrMouseMove}
          onMouseMove={this.handleMouseEnterOrMouseMove}
          onMouseLeave={this.handleMouseLeave}
        >
          <div>
            {list}
          </div>
        </div>
      </div>
    );
  };
};
class Channel extends React.Component {
  handleClick = (e) => {
    e.preventDefault();
    const service = this.props.service;
    this.props.onSelectChannel(service);
  };


  render = () => {
    const service = this.props.service;
    const selected = this.props.selected;
    const style = {margin: 0, color:'white', width: 60, height: 60, fontSize: 20}
    const logoImageUrl = service.logo_image_url;
    const backgroundImage = 'url(' + logoImageUrl + ')';
    if (selected) {
      style['backgroundImage'] = backgroundImage;

      return (
        <div style={{float:'left'}}>
          <Avatar
            style={style}
            >
            {service.remote_control_key_id}
          </Avatar>
        </div>
      );
    }
    return (
      <div style={{float:'left'}}>
      <Button
        labelStyle={{color: 'white'}}
        style={style}
        onClick={this.handleClick.bind(this)}
        >
        {service.remote_control_key_id}
      </Button>
      </div>
    );
  };
};
export default withStyles(styles)(Channels);



// WEBPACK FOOTER //
// ./src/components/Channels.js